import {
  REBOQUE_FIELD_ORDER,
  VEHICLE_FIELD_ORDER,
} from "./constants";

const pathToKey = (path = []) => path.map(String).join(".");

const getIssueSortIndex = (path = []) => {
  if (!path.length) return Number.MAX_SAFE_INTEGER;

  const [root, indexOrField, nestedField] = path;

  if (root === "reboques") {
    const rootIndex = VEHICLE_FIELD_ORDER.indexOf("reboques");
    const base = (rootIndex >= 0 ? rootIndex : VEHICLE_FIELD_ORDER.length) * 1000;

    if (typeof indexOrField === "number" || /^\d+$/.test(String(indexOrField))) {
      const reboqueIndex = Number(indexOrField);
      const fieldIndex = REBOQUE_FIELD_ORDER.indexOf(String(nestedField || ""));
      return (
        base +
        reboqueIndex * 100 +
        (fieldIndex >= 0 ? fieldIndex : REBOQUE_FIELD_ORDER.length)
      );
    }

    return base;
  }

  const fieldIndex = VEHICLE_FIELD_ORDER.indexOf(String(root));
  return fieldIndex >= 0 ? fieldIndex * 1000 : Number.MAX_SAFE_INTEGER;
};

/**
 * Converte issues do Zod para a estrutura usada pela tela e pelos modais.
 * - fieldErrors: mapa path -> mensagem (para destaque visual por campo)
 * - messages: lista ordenada e deduplicada (para o modal)
 * - firstFieldPath: caminho do primeiro campo inválido (para foco/scroll)
 */
export const mapZodErrors = (zodError) => {
  const issues = Array.isArray(zodError?.issues) ? zodError.issues : [];

  const sortedIssues = [...issues].sort(
    (a, b) => getIssueSortIndex(a.path) - getIssueSortIndex(b.path),
  );

  const fieldErrors = {};
  const messages = [];
  const seenMessages = new Set();
  let firstFieldPath = null;

  sortedIssues.forEach((issue) => {
    const message = String(issue?.message || "").trim();
    if (!message) return;

    const key = pathToKey(issue.path);
    if (key && fieldErrors[key] == null) {
      fieldErrors[key] = message;
    }

    if (!seenMessages.has(message)) {
      seenMessages.add(message);
      messages.push(message);
    }

    if (!firstFieldPath && key) {
      firstFieldPath = key;
    }
  });

  return {
    fieldErrors,
    messages,
    firstFieldPath,
  };
};
